import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/services/authenticationService'
import Store from './store'

import FrontEnd from '@/views/frontEnd.vue'
import LandingPage from '@/views/frontEnd/landing.vue'

import BackEnd from '@/views/backEnd.vue'
import Dashboard from '@/views/backEnd/dashboard.vue'
//import RCTI from '@/views/backEnd/rcti.vue'
import Allocation from '@/views/backEnd/allocation.vue'

import Trip from '@/views/backEnd/trip.vue'

import Driver from '@/views/backEnd/driver.vue'
import Tip from '@/views/backEnd/tip.vue'
import Site from '@/views/backEnd/site.vue'

import Vehicle from '@/views/backEnd/vehicle.vue'
import VehicleType from '@/views/backEnd/vehicleType.vue'
import Billing from '@/views/backEnd/billing.vue'
import ApprovedBillLine from '@/views/backEnd/approvedBillLine.vue'
import Report from '@/views/backEnd/report.vue'
import ShowReport from '@/components/reports/showReport'

import RateDetail from '@/components/rates/rateDetail.vue'
import Root from '@/views/backEnd/root/splitPageRoot.vue'

Vue.use(Router)

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/backEnd/${view}.vue`)
}

var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'frontEnd',
      component: FrontEnd,
      beforeEnter: beforeEnterFront,
      children: [
        {
          path: '',
          name: 'rootFront',
          //component: ACompomponent,
          redirect: {
            name: 'login'
          }
        },
        {
          path: '/login',
          name: 'login',
          component: LandingPage
        }
      ]
    },
    {
      path: '/app',
      name: 'backEnd',
      component: BackEnd,
      beforeEnter: beforeEnterBack,
      children: [
        {
          path: '',
          name: 'rootBack',
          //component: ACompomponent,
          redirect: {
            name: 'dashboard'
          }
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: 'user',
          name: 'user',
          component: loadView('user')
        },
        {
          path: 'userAuthClass',
          name: 'userAuthClass',
          component: loadView('userAuthClass')
        },
        {
          path: 'settings',
          name: 'settings',
          component: loadView('settings')
        },
        {
          path: 'rcti',
          name: 'rcti',
          component: loadView('rcti')
        },
        {
          path: 'client',
          name: 'client',
          component: loadView('client')
          //component: () => import('./views/backEnd/client.vue')
          //component: Client
        },
        {
          path: 'spoil',
          name: 'spoil',
          component: loadView('spoil')
        },
        {
          path: 'contractor',
          name: 'contractor',
          component: loadView('contractor')
        },
        {
          path: 'project',
          name: 'project',
          component: loadView('project')
        },
        {
          path: 'rate',
          component: Root,
          children: [
            {
              path: '',
              name: 'rate',
              component: loadView('rate')
            },
            {
              path: ':id',
              name: 'rateDetail',
              component: RateDetail
            }
          ]
        },
        {
          path: 'allocation',
          name: 'allocation',
          component: Allocation
        },
        {
          path: 'allocationStaging',
          name: 'allocationStaging',
          component: loadView('allocationStaging')
        },
        {
          path: 'docket',
          name: 'docket',
          component: Trip
        },
        {
          path: 'driver',
          name: 'driver',
          component: Driver
        },
        {
          path: 'tip',
          name: 'tip',
          component: Tip
        },
        {
          path: 'site',
          name: 'site',
          component: Site
        },
        {
          path: 'vehicle',
          name: 'vehicle',
          component: Vehicle
        },
        {
          path: 'vehicleType',
          name: 'vehicleType',
          component: VehicleType
        },
        {
          path: 'billing',
          name: 'billing',
          component: Billing
        },
        {
          path: 'approvedBillLine',
          name: 'approvedBillLine',
          component: ApprovedBillLine
        },
        {
          path: 'report',
          name: 'report',
          component: Report
          //beforeEnter: beforeEnterReport,
        },
        {
          path: 'report/show',
          name: 'showReport',
          component: ShowReport
          //beforeEnter: beforeEnterReport,
        },
        {
          path: 'tipping',
          name: 'tipping',
          component: () => import(`@/modules/tipping/tipping.vue`)
          //beforeEnter: beforeEnterReport,
        },
        {
          path: 'email',
          name: 'email',
          component: () => import(`@/modules/email/email.vue`)
          //beforeEnter: beforeEnterReport,
        },
        {
          path: 'compliance',
          name: 'compliance',
          component: loadView('compliance')
        },
        {
          path: 'audit',
          name: 'audit',
          component: loadView('audit')
        }
      ]
    }
  ]
})

export default router

const secureRoutes = [
  'rcti',
  'billing',
  'docket',
  'tip',
  'spoil',
  'client',
  'compliance',
  'contractor',
  'driver',
  'vehicle',
  'allocationStaging',
  'tipping',
  'user',
  'rate'
  // 'audit'
]
const adminPages = ['email']
function canReadPage(pageName) {
  if (['driver', 'vehicle'].includes(pageName)) pageName = 'contractor'
  if (['spoil'].includes(pageName)) pageName = 'tip'
  return Store.state.user.userAuthClass[`${pageName}Read`]
}

router.beforeEach(async (to, from, next) => {
  if (secureRoutes.includes(to.name)) {
    if (!Store.state.user.authenticated) {
      var authenticated = await Store.dispatch('user/initApp')
      if (!authenticated) {
        next({
          path: '/login'
        })
        return
      }
      canReadPage(to.name) ? next() : next({ name: 'dashboard' })
      return
    } else {
      canReadPage(to.name) ? next() : next({ name: 'dashboard' })
      return
    }
  } else if (adminPages.includes(to.name)) {
    Store.getters['user/isAdmin'] ? next() : next({ name: 'dashboard' })
    return
  } else {
    next()
    return
  }
})

async function beforeEnterFront(to, from, next) {
  var authenticated = await Store.dispatch('user/initApp')
  if (authenticated) {
    next({
      name: 'dashboard'
    })
    return
  } else {
    next()
    return
  }
}

async function beforeEnterBack(to, from, next) {
  //Store.dispatch('user/setLoading', true);
  var authenticated = await Store.dispatch('user/initApp')
  if (authenticated) {
    next()
    return
  } else {
    next({
      name: 'login'
    })
    return
  }
}

// function beforeEnterReport (to ,from, next) {
//   if (Store.state.user.user.email == 'zac@yourwebspace.com.au' || Store.state.user.user.email == 'christian@yourwebspace.com.au') {
//     next()
//     return
//   } else {
//     next({
//       name: 'dashboard'
//     });
//     return
//   }
// }

// if (authenticated) {
//   next();
// } else {
//   next({
//     path: '/login'
//   })
// }
// var token = Auth.getTokenFromStorage();
// if (!!token) {
//   Auth.useTokenForRequests(token);
//   Auth.checkAuth().then(result => {
//     ////console.log(result);

//     setAuthenticated(token, result.data.user, result.data.userDetails);
//     next();
//   }).catch(err => {
//     setLoggedOut();
//     next({
//       path: '/login'
//     })
//   });
// } else {
//   setLoggedOut();
//   next({
//     path: '/login'
//   })
// }
// function setAuthenticated(token, user, userDetails) {
//   var refreshToken = Auth.getRefreshTokenFromStorage();
//   Store.dispatch('user/setAuthenticated', { token: token, user: user, userDetails: userDetails, refreshToken: refreshToken });
//   Store.dispatch('user/setLoading', false);
//   //console.log("user was authenticated");
// }

// function setLoggedOut() {
//   Store.dispatch('user/setLogout');
//   Store.dispatch('user/setLoading', false);
//   //console.log("user was not authenticated");
// }
